define('plugin/invoice/view/InvoicePaymentButtonView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Invoice payment system view
     *
     * @class InvoicePaymentButtonView
     */
    return LayoutView.extend({

        template: '#invoice_payment_button_view',

        ui: {
            'btn': '#sb_pay_btn'
        },

        triggers: {
            'click @ui.btn': 'payment_processor:pay'
        },

        collectionEvents: {
            'sync': '_onSync'
        },

        _onSync: function() {
            if (!this.isDestroyed) {
                this.render();
            }
        },

        _delayAllowed: function () {
            return !(!this.model.get('payment_received') && this.model.get('status') === 'paid');
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);
            var selected = false;

            if (this.collection.length === 1 || (this.collection.length === 2 && !this._delayAllowed())) {
                selected = true;
            }
            data.paymentProcessorSelected = this.getOption('confirmAllowed') || selected;

            return data;
        }

    });

});
